import React from "react";

const LastestPosts = ({ posts = [] }) => {
  // Function to format the date to "DD.MM.YYYY"
  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, "0"); // Ensure two-digit day
    const month = (d.getMonth() + 1).toString().padStart(2, "0"); // Ensure two-digit month
    const year = d.getFullYear();

    return `${day}.${month}.${year}`; // Return formatted date
  };

  // Safeguard for empty posts array
  if (!posts.length) {
    return (
      <div className="container mx-auto px-4 py-8">
        <p className="text-gray-600 text-center">
          No posts available at the moment.
        </p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Header Section */}
      <div className="flex justify-between items-center border-b border-slate-200 pb-3 mb-6 mx-0 sm:mx-10">
        <a
          href="/blog/latest/"
          className="text-xl font-extrabold text-gray-900 hover:text-[rgb(126,34,206)]"
        >
          Latest Posts
        </a>
        <a
          href="/blog/latest/"
          className="rounded-sm bg-[rgba(126,34,206,0.08)] px-3 py-1.5 text-sm font-semibold text-[rgb(126,34,206)] ring-1 ring-[rgba(126,34,206,0.16)] hover:bg-[rgba(126,34,206,0.12)]"
        >
          See all
        </a>
      </div>

      {/* First Post Layout (Image Left, Info Right) */}
      <div className="bg-white shadow-sm rounded-md border border-slate-200 overflow-hidden mb-6 flex flex-col md:flex-row mx-0 sm:mx-10 transform transition-all duration-300 hover:-translate-y-0.5 hover:border-[rgba(126,34,206,0.28)] hover:shadow-md">
        <a href={posts[0]?.link} className="w-full md:w-1/2 overflow-hidden">
          <img
            src={
              posts[0]?.featuredImage
                ? `${process.env.REACT_APP_DO_SPACES_URL}${posts[0].featuredImage}`
                : "/placeholder.jpg"
            }
            alt={posts[0]?.title || "Post image"}
            className="w-full h-72 md:h-96 object-cover transform transition-all duration-500 hover:scale-105"
          />
        </a>
        <div className="w-full md:w-1/2 p-6">
          <div className="text-gray-500 text-sm font-medium flex flex-wrap items-center gap-x-2 gap-y-1">
            <span>{posts[0]?.author || "Unknown Author"}</span>
            <span>-</span>
            <span>
              {formatDate(posts[0]?.date) || "No date available"}
            </span>{" "}
            {/* Formatted date */}
            <span>-</span>
            <span>{posts[0]?.readMins || "N/A"} mins read</span>
          </div>
          <a href={posts[0]?.link} className="block mt-2">
            <h3 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 hover:text-[rgb(126,34,206)]">
              {posts[0]?.title || "Untitled Post"}
            </h3>
          </a>
          <p className="text-gray-600 mt-4 text-base sm:text-lg leading-relaxed">
            {posts[0]?.excerpt || "No excerpt available."}
          </p>
        </div>
      </div>

      {/* Other Posts Grid Layout (Image on top, content below) */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mx-0 sm:mx-10">
        {posts.slice(1).map((post, index) => (
          <div
            key={index}
            className="bg-white shadow-sm rounded-md border border-slate-200 overflow-hidden mb-6 transform transition-all duration-300 hover:-translate-y-0.5 hover:border-[rgba(126,34,206,0.28)] hover:shadow-md"
          >
            <a href={post?.link} className="block overflow-hidden">
              <img
                src={
                  post?.featuredImage
                    ? `${process.env.REACT_APP_DO_SPACES_URL}${post.featuredImage}`
                    : "/placeholder.jpg"
                }
                alt={post?.title || "Post image"}
                className="w-full h-64 object-cover transform transition-all duration-500 hover:scale-105"
              />
            </a>
            <div className="p-6">
              <div className="text-gray-500 text-sm font-medium flex flex-wrap items-center gap-x-2 gap-y-1">
                <span>{post?.author || "Unknown Author"}</span>
                <span>-</span>
                <span>
                  {formatDate(post?.date) || "No date available"}
                </span>{" "}
                {/* Formatted date */}
                <span>-</span>
                <span>{post?.readMins || "N/A"} mins read</span>
              </div>
              <a href={post?.link} className="block mt-2">
                <h3 className="text-lg font-bold text-gray-900 hover:text-[rgb(126,34,206)]">
                  {post?.title || "Untitled Post"}
                </h3>
              </a>
              <p className="text-gray-600 mt-2">
                {post?.excerpt || "No excerpt available."}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LastestPosts;
